import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 契約情報取得
 */
export namespace ApiTaCm010 {
  // API Name
  export const name: string = 'ApiTaCm010'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/contractInformation'

    export interface Request {
      query: {
        // none request parameter.
      }
    }

    export interface Response {
      currentCourseId: string
      contractInfo: Array<{
        courseId: string
        planId: string
        levelId: string
        yyMm: Array<{
          materialYyMm: number
          subjectId: string
          isDeliveried: number
          logicalYear: number
        }>
      }>
      isContractInfo: number
    }
  }

  // API本体
  export class Api
    extends ApiBase
    implements Gettable<Get.Request, Get.Response, ResponseError>
  {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        currentCourseId: '',
        contractInfo: [
          {
            courseId: '',
            planId: '',
            levelId: '',
            yyMm: [
              {
                materialYyMm: 0,
                subjectId: '',
                isDeliveried: 0,
                logicalYear: 0,
              },
            ],
          },
        ],
        isContractInfo: 0,
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
